export const blockIconsUiactionsToggleOffNew = (
	<span className='material-symbols-outlined'>toggle_off</span>
);
